define('modalView',[
  'module',
  'backbone',
  'underscore',
  'events',
  'headerFooterView',
  'modalFooterView',
  'template!modalView'
], function(
  Module,
  Backbone,
  _,
  Events,
  HeaderFooterView,
  FooterView,
  Tpl
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    template: Tpl,
    className: 'modal-view ' + HeaderFooterView.prototype.className,
    childFooterView: FooterView,

    initialize: function() {      
      if(!this.model)
        this.model = new Backbone.Model();

      HeaderFooterView.prototype.initialize.call(this);

      if(this.footerView) {
        this.footerView.on('cancel', _.bind(this.onCancel, this));
        this.footerView.on('confirm', _.bind(this.onConfirm, this));  
      }      
    },

    onDestroy: function () {
      Events.pop(this);
    },

    serializeData: function() {
      var data = {};
      return data;
    },

    onShow: function() {
      Events.push(this);
    },

    onConfirm: function () {
      if (this.options.onConfirm)
        this.options.onConfirm(this.model);
      this.windowView.close();
    },

    onCancel: function () {
      if (this.options.onCancel)
        this.options.onCancel(this.model);
      this.windowView.close();
    },

    // Static methods
    open: function (data) {
      var deferred = new $.Deferred();

      require([
        'windows',
        'modalView'
      ], function (Windows, View) {
        
        var ExtendedView = View;        
        if(data.childView)
          ExtendedView = View.extend({
            childView: data.childView
          });
          
        if(data.childFooterView)
          ExtendedView = ExtendedView.extend({
            childFooterView: data.childFooterView
          }); 

        var title = '';
        if (data.title) {
          title = data.title;
        } 

        var className = data.className || '';      
        if (data.className)
          delete data.className;

        var view = new ExtendedView(data);

        Windows.open({
          view: view,
          modal: true,
          title: title,
          className: className || ''
        });

        deferred.resolve(view);
      });

      return deferred;
    },

    close: function() {
      this.windowView.close();
    }
  });
});
